import { useParams, useNavigate } from 'react-router-dom';
import Layout from '@/components/layout/Index';
import { useEffect, useState } from 'react';
import { client } from '@/sanity/client';
import { ServiceData } from '@/types/sanity';
import ServiceDetails from '@/components/ui/services/details/ServiceDetails';
import Loader from '@/components/ui/Loader';

const ServiceDetailsPage = () => {
	const { slug } = useParams<{ slug: string }>();
	const navigate = useNavigate();
	const [service, setService] = useState<ServiceData | null>(null);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		if (!slug) {
			console.error('Slug parameter is missing');
			setIsLoading(false);
			return;
		}

		const fetchService = async () => {
			setIsLoading(true);
			try {
				const data = await client.fetch(
					`*[_type == "service" && slug.current == $slug][0]{
					_id,	
					title,
						slug,
						description,
						content,
						image,
						frequency,
						location,
						duration,
						format,
						price,
						isPerHour,
						requiresConsultation,
						consultationPrice,
						inPersonPrice,
						inPersonPriceValue,
						isPOA,
						benefits,
						workbook,
						isBookable,
						bookingStartDate,
					}`,
					{ slug },
				);

				setService(data);

				// Add a slight delay to ensure smooth loading experience
				setTimeout(() => {
					setIsLoading(false);
				}, 300);
			} catch (error) {
				console.error('Error fetching service:', error);
				setIsLoading(false);
			}
		};

		fetchService();
	}, [slug]);

	if (isLoading) {
		return <Loader />;
	}

	if (!service) {
		return (
			<Layout>
				<div className='md:p-20 p-10'>
					<p>Service not found</p>
					<button
						onClick={() => navigate('/services')}
						className='self-start px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors'
					>
						← Back to Services
					</button>
				</div>
			</Layout>
		);
	}

	return (
		<Layout>
			<div className='container mx-auto md:py-30 md:px-16 px-10 py-30 max-w-7xl'>
				<ServiceDetails service={service} />
			</div>
		</Layout>
	);
};

export default ServiceDetailsPage;
